export type CoverageState = 'understaffed' | 'at-risk' | 'adequately-staffed' | 'overstaffed'

export const COVERAGE_STATE_META: Record<CoverageState, { label: string; className: string }> = {
  understaffed: { label: 'Understaffed', className: 'text-error' },
  'at-risk': { label: 'At risk', className: 'text-warning' },
  'adequately-staffed': { label: 'Adequately staffed', className: 'text-success' },
  overstaffed: { label: 'Overstaffed', className: 'text-info' },
}

// docs/product/coverage-and-insights.md's coverage states and their
// defaults: an at-risk margin of one and an overstaffed margin of one, so two
// or more above required is overstaffed. Variance is actual minus required;
// understaffed and overstaffed are checked first since they are the two
// states a supervisor most needs to notice, then at-risk ("variance at or
// above zero but within the at-risk margin", so 0 through the margin itself,
// inclusive). With the two margins equal, nothing falls between at-risk and
// overstaffed.
export const AT_RISK_MARGIN = 1
export const OVERSTAFFED_MARGIN = 1

export function coverageStateFor(actual: number, required: number): CoverageState {
  const variance = actual - required
  if (variance < 0) return 'understaffed'
  if (variance > OVERSTAFFED_MARGIN) return 'overstaffed'
  if (variance <= AT_RISK_MARGIN) return 'at-risk'
  return 'adequately-staffed'
}
